import React from 'react';
import type { TableBlock } from '../../types';

export interface TableBlockViewProps {
  block: TableBlock;
}

export function TableBlockView({ block }: TableBlockViewProps): React.ReactElement {
  return (
    <div data-testid="block-table" className="overflow-x-auto">
      <table className="min-w-full border-collapse text-xs">
        <thead className="bg-surface-secondary">
          <tr className="border-b border-border-default">
            {block.headers.map((header, i) => (
              <th
                key={i}
                className="border border-border-default px-2 py-1.5 text-left font-semibold whitespace-nowrap"
              >
                {header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {block.rows.map((row, i) => (
            <tr key={i} className="border-b border-border-default">
              {row.map((cell, j) => (
                <td key={j} className="border border-border-default px-2 py-1.5 align-top">
                  {cell}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
